import content from '../content.json';
import { createLanguages } from './helpers';

export default createLanguages(content);